/* Minari Theme — JavaScript */
(function () {
  'use strict';

  /* ── Scroll-aware header (frosted glass) ── */
  var header = document.getElementById('site-header');
  if (header) {
    var isHomePage = !!document.querySelector('main.template-index');
    if (isHomePage) {
      function updateHeader() {
        header.classList.toggle('scrolled', window.scrollY > 80);
      }
      window.addEventListener('scroll', updateHeader, { passive: true });
      updateHeader();
    }
    /* Non-index pages: .scrolled is set by Liquid at render time — JS leaves it alone */
  }

  /* ── Mobile menu ── */
  var menuBtn  = document.getElementById('mobile-menu-btn');
  var closeBtn = document.getElementById('mobile-nav-close');
  var overlay  = document.getElementById('mobile-nav-overlay');
  var nav      = document.getElementById('mobile-nav');

  if (!menuBtn || !nav || !overlay) return;

  function openMenu() {
    nav.classList.add('is-open');
    overlay.classList.add('is-open');
    nav.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    menuBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    if (closeBtn) closeBtn.focus();
  }

  function closeMenu() {
    nav.classList.remove('is-open');
    overlay.classList.remove('is-open');
    nav.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    menuBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    menuBtn.focus();
  }

  menuBtn.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  overlay.addEventListener('click', closeMenu);

  nav.querySelectorAll('.mobile-nav-link').forEach(function (link) {
    link.addEventListener('click', closeMenu);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (nav.classList.contains('is-open')) closeMenu();
    }
  });

  /* ── Keyboard accessibility for mega menu triggers ── */
  document.querySelectorAll('.mega-trigger, .about-trigger').forEach(function (trigger) {
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', !expanded);
      }
      if (e.key === 'Escape') {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.blur();
      }
    });
  });

  /* ── Inline search panel ── */
  var searchBtn     = document.getElementById('search-btn');
  var searchPanel   = document.getElementById('search-panel');
  var searchOverlay = document.getElementById('search-overlay');
  var searchInput   = document.getElementById('search-input');
  var searchResults = document.getElementById('search-results');

  if (searchBtn && searchPanel && searchOverlay) {
    var searchTimer = null;

    function openSearch() {
      searchPanel.classList.add('is-open');
      searchOverlay.classList.add('is-open');
      searchPanel.setAttribute('aria-hidden', 'false');
      searchOverlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { if (searchInput) searchInput.focus(); }, 50);
    }

    function closeSearch() {
      searchPanel.classList.remove('is-open');
      searchOverlay.classList.remove('is-open');
      searchPanel.setAttribute('aria-hidden', 'true');
      searchOverlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      searchBtn.focus();
    }

    searchBtn.addEventListener('click', openSearch);
    searchOverlay.addEventListener('click', closeSearch);

    var panelCloseBtn = document.getElementById('search-panel-close');
    if (panelCloseBtn) panelCloseBtn.addEventListener('click', closeSearch);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchPanel.classList.contains('is-open')) closeSearch();
    });

    if (searchInput && searchResults) {
      searchInput.addEventListener('input', function () {
        clearTimeout(searchTimer);
        var q = searchInput.value.trim();
        if (!q) {
          searchResults.innerHTML = '<p class="search-prompt-label">Start typing to search</p>';
          return;
        }
        searchResults.innerHTML = '<div class="search-loading"><span></span><span></span><span></span></div>';
        searchTimer = setTimeout(function () { fetchSearch(q); }, 280);
      });
    }

    function fetchSearch(q) {
      var reqQ = q;
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!searchResults) return;
          if (searchInput.value.trim() !== reqQ) return;
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) {
            searchResults.innerHTML =
              '<p class="search-panel-status">No results</p>'
              + '<div class="search-empty-state"><p>No products matched &ldquo;' + reqQ + '&rdquo;.<br>Try a different term or browse the collection.</p></div>';
            return;
          }
          var cards = products.map(function (p) {
            var imgTag = p.featured_image
              ? '<img class="search-result-img" src="' + p.featured_image + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy">'
              : '<div class="search-result-img"></div>';
            var priceTag = p.price
              ? '<p class="search-result-price">Rs. ' + Math.round(parseInt(p.price, 10) / 100).toLocaleString() + '</p>'
              : '';
            var arrowSvg = '<svg class="search-result-arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';
            return '<a href="' + p.url + '" class="search-result-card">'
              + imgTag
              + '<div class="search-result-info"><p class="search-result-title">' + p.title + '</p>' + priceTag + '</div>'
              + arrowSvg
              + '</a>';
          }).join('');

          var viewAll = '<a href="/search?type=product&q=' + encodeURIComponent(reqQ) + '" class="search-view-all">'
            + '<span>View all results for &ldquo;' + reqQ + '&rdquo;</span>'
            + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>'
            + '</a>';

          searchResults.innerHTML =
            '<p class="search-panel-status">' + products.length + ' product' + (products.length > 1 ? 's' : '') + ' found</p>'
            + '<div class="search-results-list">' + cards + '</div>'
            + viewAll;

          searchResults.querySelectorAll('.search-result-card').forEach(function (card) {
            card.addEventListener('click', closeSearch);
          });
        })
        .catch(function () {
          if (searchResults) searchResults.innerHTML = '<div class="search-empty-state"><p>Search unavailable. Please try again.</p></div>';
        });
    }
  }
})();
